import { createViewData } from './_ViewData';
import { createAppViewsInner } from './_Views';
import { Store } from '../store/Store';

export const createAppViews = (getStore: () => Store) => {
    return createAppViewsInner(getStore, createViewData);
};
export type AppViews = ReturnType<typeof createAppViews>;